<!--
@Time : 2020/11/28 7:27 下午
@Author : yekong
@File : shengmingzhouqi.vue
@Software : PhpStorm
-->
<template>
  <div>
    <titles title="企业生命周期"></titles>
    <div ref="echarts" :style="{width: '820px', height: '500px'}"></div>
  </div>
</template>

<script>
import titles from "@/components/title";

export default {
  name: "shengmingzhouqi",

  components: {titles},
  data: function () {
    return {}
  },
  props: {
    top: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  created: function () {

  },
  filters: {},
  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(this.$refs.echarts)
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: 'item'
        },
        series: [{
          type: 'pie',
          center: ['50%', '50%'],
          radius: ['35%', '70%'],
          minAngle: 10,
          avoidLabelOverlap: true,
          roseType: 'radius',
          hoverOffset: 15,
          itemStyle: {
            color: function (params) {
              var colorList = ['#b5ba76', '#4ca698', '#3165e3', '#05a1ef', '#316513'];
              return colorList[params.dataIndex];
            },
          },
          labelLine: {
            normal: {
              lineStyle: {
                color: 'rgba(114, 189, 255, 1)',
                fontSize: 30
              }
            }
          },
          label: {
            show: true,
            position: 'outer',
            width: 0,
            height: 0,
            fontSize: 30,
            lineHeight: 0,
            backgroundColor: 'auto',
            padding: [2, -2, 2, -2],
            borderRadius: 2,
            distanceToLabelLine: 0,
            align: 'center',
            formatter: function (params) {
              console.log(params)
              return params.name + params.value + "分";
            },
            textStyle: {
              color: 'rgba(114, 189, 255, 1)'
            },
            rich: {
              top: {
                verticalAlign: 'bottom',
                padding: [10, 10, 0, 10],
                align: 'center',
                fontSize: 30,
                color: '#71bdff'
              },
              bottom: {
                padding: [0, 10, 10, 10],
                verticalAlign: 'top',
                align: 'center'
              }
            }
          },
          data: [{
            name: '人才供给',
            value: 91
          }, {
            name: '企业信用',
            value: 91
          }, {
            name: '法制环境',
            value: 91
          }, {
            name: '企业运用成本',
            value: 91
          }, {
            name: '融投资',
            value: 91
          }]
        }]
      });
    }

  },
  mounted() {
    this.drawLine();
  },
}
</script>

<style lang="scss" scoped>

</style>
